// extracted by mini-css-extract-plugin
export var label = "_7f-1";
export var reminder = "_7f-0";